export enum ProductState {
  RAW = "Raw",
  COOKED = "Cooked",
  HOT = "Hot",
  Undefined = ""
}

export class ProductStateEnumMapper {
  static toString(state: string): string {
    if (state === "RAW") {
      return $localize`:@@raw:Raw`
    } else if (state === "COOKED") {
      return $localize`:@@cooked:Cooked`
    } else if (state === "HOT") {
      return $localize`:@@hot:Hot`
    } else {
      return ProductState.Undefined
    }
  }
}
